export default "__VITE_ASSET__Cfc2hDXX__"